import React from 'react'

class PageHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {  
        return(
            <div
                className={"page-header " + (this.props.contain ? "contain" : "") + (this.props.cover ? " cover" : "")}
                style={{
                    ...this.props.styles,
                    backgroundImage: `url('${this.props.bgPhoto}')`
                }}
            />
        )
    }
}
  
export default PageHeader


// WEBPACK FOOTER //
// ./src/__components/PageHeader.js